webpackJsonp([222457311475995],{

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(57);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Kontakt = function Kontakt() {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "article",
	      null,
	      _react2.default.createElement(_reactHelmet2.default, { title: "Muvko - Kontakt" }),
	      _react2.default.createElement(
	        "div",
	        { className: "ContactInfo u-flexRow" },
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "h2",
	            null,
	            "Michal"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Tel: ",
	            _react2.default.createElement(
	              "a",
	              { href: "tel://+420730175491" },
	              "+420 730 175 491"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "h2",
	            null,
	            "Katka"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Tel: ",
	            _react2.default.createElement(
	              "a",
	              { href: "tel://+420730526102" },
	              "+420 730 526 102"
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "form",
	        { className: "ContactForm",
	          action: "https://formspree.io/rejdova.kat@gmail.com",
	          method: "POST"
	        },
	        _react2.default.createElement(
	          "label",
	          { htmlFor: "name" },
	          "Jm\xE9no"
	        ),
	        _react2.default.createElement("input", { type: "text", name: "name", id: "name" }),
	        _react2.default.createElement(
	          "label",
	          { htmlFor: "email" },
	          "Email"
	        ),
	        _react2.default.createElement("input", { type: "email", name: "_replyto", id: "email" }),
	        _react2.default.createElement(
	          "label",
	          { htmlFor: "message" },
	          "Zpr\xE1va"
	        ),
	        _react2.default.createElement("textarea", { name: "message", id: "message" }),
	        _react2.default.createElement("input", { className: "Button", type: "submit", value: "Poslat" }),
	        _react2.default.createElement("input", { type: "hidden", name: "_next", value: "/thanks" }),
	        _react2.default.createElement("input", { type: "hidden", name: "_cc", value: "g.sus@seznam.cz,em.starostka@gmail.com" })
	      )
	    ),
	    _react2.default.createElement("iframe", {
	      className: "u-mt2",
	      src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2558.729815201262!2d14.449269316473641!3d50.11006397942979!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470beb4ceb21ae9d%3A0xd344b02a79eb802e!2sEnergym!5e0!3m2!1sen!2scz!4v1520820601109",
	      frameBorder: "0",
	      style: { border: 0, width: '100%', height: '400px' },
	      allowFullScreen: true
	    })
	  );
	};
	
	exports.default = Kontakt;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-kontakt-js-22466e312d2ae4c28cb9.js